var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, action } from 'mobx';
import { api } from 'helpers/Api';
import { Tax, TaxCategory } from './Model';
var default_1 = /** @class */ (function () {
    function default_1() {
        var _this = this;
        this.taxes = [];
        this.loaded = false;
        this.set = function (taxes) {
            _this.taxes = taxes.map(function (tax) { return new Tax(tax); });
            _this.loaded = true;
            return _this.taxes;
        };
        this.push = function (tax) {
            _this.taxes.push(new Tax(tax));
        };
        this.replace = function (tax) {
            _this.taxes.splice(_this.taxes.findIndex(function (f) { return f.id === tax.id; }), 1, tax);
        };
    }
    Object.defineProperty(default_1.prototype, "articleTaxes", {
        get: function () {
            return this.taxes.filter(function (tax) { return tax.category === TaxCategory.Article; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(default_1.prototype, "customerTaxes", {
        get: function () {
            return this.taxes.filter(function (tax) { return tax.category === TaxCategory.Customer; });
        },
        enumerable: false,
        configurable: true
    });
    default_1.prototype.read = function (id) {
        if (id)
            return api.get('taxes/' + id);
        return api.get('taxes').then(this.set);
    };
    default_1.prototype.create = function (tax) {
        return api.post('taxes', tax).then(this.push);
    };
    default_1.prototype.update = function (id, tax) {
        var _this = this;
        return api.put('taxes/' + id, tax)
            .then(function (result) {
            console.log('then - result', result);
            _this.replace(result);
        });
    };
    default_1.prototype.findById = function (id) {
        return this.taxes.filter(function (value) { return value.id === Number(id); })[0];
    };
    __decorate([
        observable
    ], default_1.prototype, "taxes", void 0);
    __decorate([
        observable
    ], default_1.prototype, "loaded", void 0);
    __decorate([
        computed
    ], default_1.prototype, "articleTaxes", null);
    __decorate([
        action
    ], default_1.prototype, "set", void 0);
    __decorate([
        action
    ], default_1.prototype, "push", void 0);
    __decorate([
        action
    ], default_1.prototype, "replace", void 0);
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/Store.ts
// module id = 691
// module chunks = 0